// Centralized API configuration
const envApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5025/api';
const envSocketUrl = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5025/';

// Remove trailing slash from API URL if present
const normalizedApiUrl = envApiUrl.replace(/\/$/, '');

// Ensure Socket URL has trailing slash
const normalizedSocketUrl = envSocketUrl.endsWith('/') ? envSocketUrl : `${envSocketUrl}/`;

export const API_CONFIG = {
    BASE_URL: normalizedApiUrl,
    baseURL: normalizedApiUrl,
    SOCKET_URL: normalizedSocketUrl,

    // Helper methods for common API operations
    getUrl: (endpoint) => {
        // Remove leading slash from endpoint if present
        const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
        return `${normalizedApiUrl}/${cleanEndpoint}`;
    },

    getHeaders: (includeAuth = true) => {
        const headers = {
            'Content-Type': 'application/json',
        };

        if (includeAuth) {
            const token = localStorage.getItem('token');
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
        }

        return headers;
    }
};

// Export individual values for backward compatibility
export const API_BASE_URL = normalizedApiUrl;
export const SOCKET_URL = normalizedSocketUrl;

// Default export
export default API_CONFIG;